module.exports = __webpack_public_path__ + "img/9788962602630.0f381a2d.jpg";